import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CompartidoModule } from './librerias/compartido.module';
import { FiltroPipe } from './pipe/filtro.pipe';
import { TimeOutService } from './service/time-out.services';


@NgModule({
  declarations: [AppComponent, FiltroPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CompartidoModule,

  ],
  providers: [
    TimeOutService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
